var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84 16.073h5.088v5.09c0 .147.121.267.268.267h1.607c.148 0 .268-.12.268-.268v-5.089h5.09c.147 0 .267-.12.267-.268v-1.607a.269.269 0 00-.267-.268h-5.09V8.84a.269.269 0 00-.268-.267h-1.607a.269.269 0 00-.268.268v5.09H8.84a.269.269 0 00-.268.267v1.607c0 .147.12.268.268.268z",
    fill: "#D9D9D9",
    stroke: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.322 1.608H2.679a1.07 1.07 0 00-1.072 1.071v24.643a1.07 1.07 0 001.072 1.071h24.643a1.07 1.07 0 001.071-1.071V2.679a1.07 1.07 0 00-1.071-1.071zm-1.34 24.375H4.018V4.018h21.964v21.965z",
    fill: "#D9D9D9",
    stroke: "#F4F4F4"
  })));
}
export default SvgAdd;